// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/vsi.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/vsi/vsi.js';

mount([g0]);
